import React, { useMemo } from 'react';

const DCPreviewContent = ({ dcData, selectedFirm, printRef }) => {
  const totals = useMemo(() => {
    if (!dcData || !dcData.components) return { totalQty: 0 };
    return dcData.components.reduce((acc, c) => {
      acc.totalQty += (parseInt(c.newQty || 0) + parseInt(c.rentalQty || 0));
      return acc;
    }, { totalQty: 0 });
  }, [dcData]);

  if (!dcData) return null;

  const pdfContainerStyle = { backgroundColor: 'white', padding: '40px', border: '1px solid #e2e8f0', minHeight: '1000px', color: '#000', boxSizing: 'border-box' };
  const headerTableStyle = { width: '100%', borderCollapse: 'collapse', border: '1px solid #000' };
  const headerTableCellStyle = { border: '1px solid #000', padding: '8px', fontSize: '12px', textAlign: 'left' };
  const pdfThStyle = { border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'center', fontWeight: 'bold' };
  const pdfTdStyle = { border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'left' };

  return (
    <div style={pdfContainerStyle} ref={printRef}>
      {/* SECTION 1: HEADER */}
      <table style={headerTableStyle}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '20%', textAlign: 'center' }}>
              {selectedFirm?.logo && <img src={selectedFirm.logo} alt="Logo" style={{ maxWidth: '120px' }} />}
            </td>
            <td style={{ ...headerTableCellStyle, width: '50%', fontSize: '12px' }}>
              <strong style={{ fontSize: '16px' }}>{selectedFirm?.name}</strong><br />
              {selectedFirm?.address}<br />
              GSTIN: {selectedFirm?.gstin}<br />
              Email: {selectedFirm?.email} | Tel: {selectedFirm?.tel}
            </td>
            <td style={{ ...headerTableCellStyle, width: '30%', textAlign: 'center', verticalAlign: 'middle' }}>
              <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '900' }}>DELIVERY CHALLAN</h1>
            </td>
          </tr>
        </tbody>
      </table>

      {/* SECTION 2: DOCUMENT & DELIVERY */}
      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Document Details</td>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Delivery Details</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Challan#:</strong> {dcData.challanNo}</td>
            <td style={headerTableCellStyle}><strong>PO Number:</strong> {dcData.poNumber}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Dispatch Date:</strong> {dcData.dispatchDate}</td>
            <td style={headerTableCellStyle}><strong>PO Date:</strong> {dcData.poDate}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Delivery Agent:</strong> {dcData.deliveryAgent}</td>
            <td style={headerTableCellStyle}><strong>Delivery Mode:</strong> {dcData.deliveryMode} (Type: {dcData.vehicleType || '---'})</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Coordinator:</strong> {dcData.coordinator}</td>
            <td style={headerTableCellStyle}><strong>Dispatched Through:</strong> {dcData.dispatchedThrough}</td>
          </tr>
          {dcData.irnNo && (
            <tr><td colSpan="2" style={headerTableCellStyle}><strong>IRN#:</strong> {dcData.irnNo}</td></tr>
          )}
        </tbody>
      </table>

      {/* SECTION 3: BILL TO | SHIP TO */}
      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Bill to</td>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Ship to</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Customer:</strong> {dcData.billToCustomer}</td>
            <td style={headerTableCellStyle}><strong>Customer:</strong> {dcData.shipToCustomer}</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, height: '50px', verticalAlign: 'top' }}><strong>Address:</strong> {dcData.billToAddress}</td>
            <td style={{ ...headerTableCellStyle, height: '50px', verticalAlign: 'top' }}><strong>Address:</strong> {dcData.shipToAddress}</td>
          </tr>
          <tr><td style={headerTableCellStyle}><strong>GSTIN/UIN:</strong> {dcData.billToGstin}</td><td rowSpan={2} style={headerTableCellStyle}></td></tr>
          <tr><td style={headerTableCellStyle}><strong>Salesperson:</strong> {dcData.salesperson}</td></tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Order By:</strong> {dcData.orderBy}<br/><strong>Contact:</strong> {dcData.orderByContact}</td>
            <td style={headerTableCellStyle}><strong>Site Person:</strong> {dcData.sitePerson}<br/><strong>Contact:</strong> {dcData.sitePersonContact}</td>
          </tr>
          <tr><td style={headerTableCellStyle}><strong>Email:</strong> {dcData.billToEmail}</td><td style={headerTableCellStyle}><strong>Email:</strong> {dcData.shipToEmail}</td></tr>
        </tbody>
      </table>

      {/* SECTION 4: ITEM SUMMARY */}
      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '33%' }}><strong>Item code:</strong> {dcData.itemCode}</td>
            <td style={{ ...headerTableCellStyle, width: '33%' }}><strong>Tower Height:</strong> {dcData.towerHeight}</td>
            <td style={{ ...headerTableCellStyle, width: '34%' }}><strong>Total Meter:</strong> {dcData.totalMeter}</td>
          </tr>
        </tbody>
      </table>

      {/* SECTION 5: MATERIAL TABLE */}
      <div style={{ marginTop: '20px' }}>
          <div style={{ backgroundColor: '#f1f5f9', padding: '8px 10px', border: '1px solid #000', borderBottom: 'none', fontWeight: 'bold', fontSize: '14px' }}>MATERIAL BREAKDOWN</div>
          <table style={headerTableStyle}>
              <thead>
                  <tr style={{ backgroundColor: '#f8fafc' }}><th style={pdfThStyle}>Sr. No.</th><th style={pdfThStyle}>SKU</th><th style={{...pdfThStyle, textAlign:'left'}}>Item</th><th style={pdfThStyle}>Qty Per Set</th><th style={pdfThStyle}>Total Qty</th></tr>
              </thead>
              <tbody>
                  {dcData.components?.map((c, i) => (
                      <tr key={i}>
                          <td style={{...pdfTdStyle, textAlign:'center'}}>{i+1}</td><td style={{...pdfTdStyle, textAlign:'center'}}>{c.sku}</td><td style={pdfTdStyle}>{c.name}</td>
                          <td style={{...pdfTdStyle, textAlign:'center'}}>{c.perSet}</td><td style={{...pdfTdStyle, textAlign:'center', fontWeight:'bold'}}>{parseInt(c.newQty || 0) + parseInt(c.rentalQty || 0)}</td>
                      </tr>
                  ))}
                  <tr style={{ backgroundColor: '#f8fafc', fontWeight: 'bold' }}><td colSpan="4" style={{ ...pdfTdStyle, textAlign: 'right', paddingRight: '10px' }}>TOTAL QUANTITY:</td><td style={{ ...pdfTdStyle, textAlign: 'center' }}>{totals.totalQty}</td></tr>
              </tbody>
          </table>
      </div>
      
      {/* SECTION 6: TERMS & CONDITIONS */}
      <table style={{ ...headerTableStyle, borderTop: 'none', marginTop:'20px' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}><td style={{ ...headerTableCellStyle, fontSize: '14px' }}>Terms and Conditions</td></tr>
          <tr>
            <td style={{ ...headerTableCellStyle, fontSize: '11px', lineHeight: '1.6' }}>
                1. Have received the material in good condition and satisfied with the quality of same.<br/>
                2. Have read the scaffold safety notes and also the instructions given by the Nexrise India team for proper use of the scaffold.<br/>
                3. Received and carefully read the scaffold safety notes for meticulous compliance at site.<br/>
                4. Have verified and cross checked the material quantity. Any post discrepancy or issue for material condition will not be acceted.
            </td>
          </tr>
        </tbody>
      </table>

      {/* SECTION 7: SIGNATURES */}
      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>
                <strong>Received By (Name):</strong> {dcData.receivedByName || '____________________'}<br/><br/>
                <strong>Contact Number:</strong> {dcData.receivedByContact || '____________________'}<br/><br/>
                <strong>Date & Time of Handover:</strong> {dcData.handoverDateTime || '____________________'}
            </td>
            <td style={{ ...headerTableCellStyle, width: '50%', textAlign: 'center', verticalAlign: 'bottom', height: '120px' }}>
                <strong>Customer seal and Signature</strong>
            </td>
          </tr>
        </tbody>
      </table>

      {/* SECTION 8: INTERNAL PURPOSE ONLY */}
      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td colSpan="5" style={{ ...headerTableCellStyle, textAlign: 'center' }}>Internal Purpose Only</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '20%', verticalAlign: 'center',}}><strong>Verified and Checked By:</strong></td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '20%' }}></td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '20%', textAlign: 'center', verticalAlign: 'bottom', paddingBottom: '15px' }}>
                <strong>Seal & Sign (Consignor)</strong>
            </td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '20%', textAlign: 'center', verticalAlign: 'top' }}>
                <strong>Prepared By:</strong><br/>
                <div style={{ height: '110px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/Rajesh-Kumar-Sign.png" alt="Sign" style={{ maxHeight: '100px', objectFit: 'contain' }} />
                </div>
                Rajesh Kumar
            </td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '20%', textAlign: 'center', verticalAlign: 'top' }}>
                <strong>Approved By:</strong><br/>
                <div style={{ height: '110px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/Ghansyam-Sign.png" alt="Sign" style={{ maxHeight: '100px', objectFit: 'contain' }} />
                </div>
                Ghanshyam Prajapt
            </td>
          </tr>
          <tr><td style={{ ...headerTableCellStyle, verticalAlign: 'center' }}><strong>Time & date:</strong></td></tr>
          <tr><td style={{ ...headerTableCellStyle, verticalAlign: 'center' }}><strong>Sign:</strong></td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default DCPreviewContent;
